// @flow

import { toASCII } from 'punycode';

import type {
  Process,
  ProductData,
  ProductPayload,
  ProductType,
} from '@gandi/cart';

import { divideTldFromBaseDomain } from 'src/modules/domain';

import type { DomainProduct } from '../../types';

type DomainProductData = {
  extra: { identifier?: string, label?: string, optimisticId?: string },
  productData: {
    authentication?: { password: string },
    bundle_id?: number,
    fqdn?: string,
    identifier?: string,
    label?: string,
    metadatas?: ProductData['metadatas'],
    payload?: ProductPayload,
    process: Process,
    product_type: ProductType,
    service_id?: string,
  },
};

export function getTransferProductData(
  domain: DomainProduct,
): DomainProductData {
  return {
    extra: {
      label: domain.fqdn,
    },
    productData: {
      product_type: 'domain',
      process: 'transfer',
      payload: {
        fqdn: domain.fqdn,
        duration: domain.durations[0],

        // TODO: add this field
        // change_owner: domain.extTrade,

        // TODO: add this field
        // authinfoForTransfer: domain.authinfoForTransfer,

        tld: divideTldFromBaseDomain(domain.fqdn).tld,
        options: {
          durations: domain.durations,
        },
        // INFO: `mailbox_optin` should be handled by the API:
        //       https://gitlab.corp.gandi.net/gandi/admin-v5/admin/-/merge_requests/10291#note_1092438
        // mailbox_optin: true,

        corporate: domain.corporate,
        internal: domain.internal,
      },
    },
  };
}

export function getDomainCreateProductData(
  domain: DomainProduct,
): DomainProductData {
  return {
    extra: {
      label: domain.fqdn,
    },
    productData: {
      product_type: 'domain',
      process: 'create',
      payload: {
        tld: divideTldFromBaseDomain(domain.fqdn).tld,
        fqdn: toASCII(domain.fqdn),

        // TODO: getMinDuration fix the minimum_duration depending of the phase
        // duration: getMinDuration(domain),
        duration: domain.minimum_duration,

        // TODO: set the real phase, correct prices catalog are required
        // tld_phase: domain.phase,
        tld_phase: 'golive',

        lang: undefined,
        corporate: domain.corporate,

        // TODO: needed if EAP
        // phase_date_start: phase?.starts_at,
        // phase_date_end: phase?.ends_at,

        // INFO: `mailbox_optin` should be handled by the API:
        //       https://gitlab.corp.gandi.net/gandi/admin-v5/admin/-/merge_requests/10291#note_1092438
        // mailbox_optin: true,
      },
    },
  };
}
